import { atom } from "jotai";

export const isNoSelectedServicesQuotingAtom = atom<boolean>(true);
export const isNoSelectedServicesInvoicingAtom = atom<boolean>(true);

export const expensesSortByAtom = atom<string>('')
export const expensesSortOrderAtom = atom<string>('')

export const productsAndServicesSortByAtom = atom<string>('')
export const productsAndServicesSortOrderAtom = atom<string>('')